import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dialog', 'frame'];

  open(event) {
    event.preventDefault();
    event.stopPropagation();

    const url = event.currentTarget.dataset.activityUrl;
    if (!url || !this.hasFrameTarget) return;

    this.frameTarget.src = url;
    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.dialogTarget.close();
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }
}
